<img [src]="getPath()" />
